/**
 * Adaptador do Facebook Messenger para o shell compartilhado do inbox.
 * Tudo que era fiacao do canal no antigo pages/messenger/* mora aqui.
 */
import { Facebook } from 'lucide-react';
import messengerService from '../../../services/messenger/messengerService';
import MessengerConnectionModal from '../../messenger/MessengerConnectionModal';
import { publishMessengerStatus } from '../../NavSidebar';
import { loadMessengerMessages } from '../../../services/inbox/chatMessageLoaders';

const MS_NATIVE_TYPES = ['image', 'audio', 'video'];

const messengerAdapter = {
  code: 'messenger',
  label: 'Messenger',
  prefix: 'messenger:',
  keyField: 'contact_psid',
  shortKey: 'psid',
  route: '/messenger',
  Icon: Facebook,
  color: '#0084ff',
  service: messengerService,
  loadMessages: (chatId) => loadMessengerMessages(chatId),
  // Midia: o Messenger envia image/audio/video como nativos e o resto (pdf,
  // doc, planilha) como anexo generico 'file'.
  normalizeMediaType: (t) => (MS_NATIVE_TYPES.includes(t) ? t : 'file'),
  allowDocument: true,
  allowAudio: true,
  windowed: true,
  hasHandle: false,
  sendMedia: (chat, url, type) => messengerService.sendMedia(chat.contact_psid, url, type),
  handoffDismissKey: 'handoffDismissedMS',
  ConnectionModal: MessengerConnectionModal,
  publishStatus: publishMessengerStatus,
  // Facebook Login tem DOIS passos: connect-oauth devolve a lista de Paginas.
  oauth: {
    stateKey: 'ms_oauth_state',
    twoStep: true,
    cancelledText: 'Autorização cancelada ou recusada no Facebook.',
    exchangingText: 'Conectando com o Facebook...',
  },
  headerStatus: () => 'Messenger',
  texts: {
    searchPlaceholder: 'Pesquisar por nome',
    searchHint: 'Tente buscar por outro nome',
    emptyHint: (account) => `As conversas aparecem aqui quando alguém enviar uma mensagem${account?.page_name ? ` para a Página ${account.page_name}` : ' para a Página'}. No Messenger a empresa não pode iniciar a conversa.`,
    placeholderHint: 'No Messenger a conversa começa sempre pelo cliente. Você tem 24 horas para responder cada mensagem recebida.',
    noAccount: 'Nenhuma Página do Facebook conectada',
    connectButton: 'Conectar Messenger',
    closedNotice: (name) => `A janela de 24 horas do Messenger fechou. Só é possível responder depois que ${name} enviar uma nova mensagem — o Messenger não permite retomar a conversa por iniciativa da empresa.`,
  },
};

export default messengerAdapter;
